import { render, staticRenderFns } from "./MyApplications_Leave.vue?vue&type=template&id=97488aba&scoped=true"
import script from "./MyApplications_Leave.vue?vue&type=script&lang=js"
export * from "./MyApplications_Leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97488aba",
  null
  
)

export default component.exports